import { useSetAtom } from 'jotai';
import { useCallback } from 'react';

import { meOrgState } from '../atom';
import type { Organization } from '../types';

export function useUpsert() {
  const setMeOrganization = useSetAtom(meOrgState);

  const upsert = useCallback(
    (input: Organization) => {
      setMeOrganization((prev) => ({
        ...prev,
        ...input,
      }));
    },
    [setMeOrganization]
  );

  return { upsert };
}
